import { useEffect } from 'react';

/**
 * Loads Plausible Analytics when REACT_APP_PLAUSIBLE_DOMAIN is set.
 * Add to your domain at plausible.io, then set the env var in Vercel.
 */
export function Analytics() {
  const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;

  useEffect(() => {
    if (!domain) return;
    const script = document.createElement('script');
    script.defer = true;
    script.dataset.domain = domain;
    script.src = 'https://plausible.io/js/script.js';
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [domain]);

  return null;
}
